import _ from 'lodash'
import api from '@/api'

const state = {
  pharmacies: [],
  selectedPharmacyIds: []
}

const getters = {
  pharmacies: state => state.pharmacies,
  selectedPharmacyIds: state => state.selectedPharmacyIds,
  selectedPharmacies: state => {
    return _.map(state.selectedPharmacyIds, id => {
      return _.find(state.pharmacies, p => p.pharmacyId === id)
    })
  }
}

const mutations = {
  setPharmacies(state, pharmacies) {
    state.pharmacies = pharmacies
  },
  toggleSelectedPharmacyId (state, pharmacyId) {
    let index = _.findIndex(state.selectedPharmacyIds, id => id == pharmacyId)
    if (index === -1) {
      if (state.selectedPharmacyIds.length < 10) {
        state.selectedPharmacyIds.push(pharmacyId)
      }
    } else {
      state.selectedPharmacyIds.splice(index, 1)
    }
  },
  setSelectedPharmacyIds (state, pharmacyIds) {
    state.selectedPharmacyIds = pharmacyIds
  },
  removeSelectedPharmacyId (state, index) {
    state.selectedPharmacyIds.splice(index, 1)
  }
}

const actions = {
  async getPharmacies ({ commit }) {
    commit('setPharmacies', await api.st.getPharmacies())
  },
  selectPharmacy ({ commit }, pharmacy) {
    commit('toggleSelectedPharmacyId', pharmacy.pharmacyId)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}